import { render, staticRenderFns } from "./ProductTypeForm.vue?vue&type=template&id=d6857fe6&"
import script from "./ProductTypeForm.vue?vue&type=script&lang=js&"
export * from "./ProductTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports